export function Marquee({ opponent, prize }) {
  const winLine = prize
    ? `Tippe mit und gewinne mit etwas Glück: ${prize}`
    : "Tippe mit und gewinne mit etwas Glück";
  const items = [
    winLine,
    "Oberliga Westfalen",
    opponent ? `Heute gegen ${opponent}` : "TSG Sprockhövel Tip-Battle",
    "TSG Sprockhövel",
  ];
  const loop = [...items, ...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 py-5 bg-[#123a6b]/30"
      data-testid="marquee"
    >
      <div className="marquee">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-head text-2xl sm:text-3xl font-medium tracking-wide uppercase px-6 flex items-center gap-6 whitespace-nowrap"
          >
            <span className={i % 2 === 0 ? "text-white" : "text-[#e9b44c]"}>{t}</span>
            <span className="text-[#e9b44c] text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
